import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, InputNumber, Button, message, Select, Form } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Calculator = props => {
    
    const history = useHistory()
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);

    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [form_calculator_1] = Form.useForm();

    const [water, setWater] = useState({});

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    useEffect(async () => {
        component_start()
    }, [profile.token]);

    async function component_start() {
        
    }

    async function form_finish_calculator_1(v) {
        if (v.weight && v.activity && v.climate) {
            console.log(v);
            let new_water = (+v.weight*+v.activity*+v.climate).toFixed(1);

            let activity_text = '';
            let climate_text = '';

            if (v.activity === 0.03) { activity_text = 'с минимальной степенью активности'; }
            if (v.activity === 0.04) { activity_text = 'с низкой степенью активности'; }
            if (v.activity === 0.05) { activity_text = 'со средней степенью активности'; }
            if (v.activity === 0.06) { activity_text = 'с высокой степенью активности'; }
            if (v.activity === 0.07) { activity_text = 'с очень высокой степенью активности'; }

            if (v.climate === 0.8) { climate_text = 'холодным климатом'; }
            if (v.climate === 1) { climate_text = 'умеренным климатом'; }
            if (v.climate === 1.2) { climate_text = 'меплым климатом'; }
            if (v.climate === 1.5) { climate_text = 'очень жарким климатом'; }

            setWater({
                volume:new_water,
                weight:v.weight,
                activity:v.activity,
                climate:v.climate,
                activity_text:activity_text,
                climate_text:climate_text
            });
        } else {
            setWater({});
            message.info('Необходимо заполнить все поля');
        }
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <section className='container_full --calculator_2'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Калькулятор воды в организме</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/4/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/calculator_imt_6.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Потребляйте достаточное количество воды</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/calculator_imt_7.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/checkup_health/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/calculator_imt_8.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Check up здоровья</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/calculators/1/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/calculator_imt_9.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Калькулятор ИМТ</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/food_products/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/calculator_imt_10.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Топ-10 продуктов питания</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/4/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/calculator_imt_6.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Потребляйте достаточное количество воды</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/calculator_imt_7.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/checkup_health/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/calculator_imt_8.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Check up здоровья</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/calculators/1/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/calculator_imt_9.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Калькулятор ИМТ</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/food_products/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/calculator_imt_10.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Топ-10 продуктов питания</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='body'>
                                            <h2>Калькулятор воды</h2>
                                            <Form name="form" className="default_form" form={form_calculator_1} onFinish={form_finish_calculator_1} >
                                                <label>Ваш вес <span>(кг)</span></label>
                                                <Form.Item name={`weight`} rules={[{ required: true, message: `Пожалуйста, введите вес!` }]}>
                                                    <InputNumber min={0} className='custom_input' />
                                                </Form.Item>
                                                <label>Ваша активность</label>
                                                <Form.Item name={`activity`} rules={[{ required: true, message: `Пожалуйста, выберите активность!` }]}>
                                                    <Select
                                                        className="custom_select"
                                                        defaultValue={``}
                                                        placeholder="Активность"
                                                        options={[
                                                            {value:0.03,label:"Минимальная активность"},
                                                            {value:0.04,label:"Низкая активность"},
                                                            {value:0.05,label:"Средняя активность"},
                                                            {value:0.06,label:"Высокая активность"},
                                                            {value:0.07,label:"Очень высокая активность"},
                                                        ]}
                                                    />
                                                </Form.Item>
                                                <label>Климатические условия</label>
                                                <Form.Item name={`climate`} rules={[{ required: true, message: `Пожалуйста, выберите климатические условия!` }]}>
                                                    <Select
                                                        className="custom_select"
                                                        defaultValue={``}
                                                        placeholder="Активность"
                                                        options={[
                                                            {value:0.8,label:"Холодный климат"},
                                                            {value:1,label:"Умеренный климат"},
                                                            {value:1.2,label:"Теплый климат"},
                                                            {value:1.5,label:"Очень жаркий климат"},
                                                        ]}
                                                    />
                                                </Form.Item>
                                                <div className='form_buttons'>
                                                    <Button className='submit' htmlType="submit" >Узнать</Button>
                                                </div>
                                            </Form>

                                            {Object.keys(water).length > 0 ?
                                                <div className='result'>
                                                    <h3>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_734_2021)">
                                                            <path d="M23.5013 17.9972L15.0233 2.41243C13.6612 0.119256 10.3407 0.116209 8.9767 2.41243L0.499073 17.9972C-0.893396 20.3405 0.792463 23.3078 3.52167 23.3078H20.478C23.2049 23.3078 24.8938 20.3429 23.5013 17.9972ZM12 20.4953C11.2248 20.4953 10.5937 19.8642 10.5937 19.089C10.5937 18.3138 11.2248 17.6828 12 17.6828C12.7752 17.6828 13.4062 18.3138 13.4062 19.089C13.4062 19.8642 12.7752 20.4953 12 20.4953ZM13.4062 14.8703C13.4062 15.6455 12.7752 16.2765 12 16.2765C11.2248 16.2765 10.5937 15.6455 10.5937 14.8703V7.83901C10.5937 7.06379 11.2248 6.43276 12 6.43276C12.7752 6.43276 13.4062 7.06379 13.4062 7.83901V14.8703Z" fill="#487CAB"/>
                                                            </g>
                                                            <defs>
                                                            <clipPath id="clip0_734_2021">
                                                            <rect width="24" height="24" fill="white"/>
                                                            </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <span>Необходимый объем воды - {water.volume} л</span>
                                                    </h3>
                                                    <p>Таким образом, для человека весом {water.weight} кг, {water.activity_text} и {water.climate_text} необходимый объем воды {water.volume} л в день.</p>
                                                </div>
                                            :
                                                null
                                            }
                                        </div>
                                        <div className='body right'>
                                            <img src={`${IMAGES}/banners/calculator_imt_11.jpeg`} />
                                            <div className='text'>
                                                <svg width="52" height="50" viewBox="0 0 52 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M50.9196 38.2596L32.5505 3.80482C29.5992 -1.2649 22.4048 -1.27164 19.4495 3.80482L1.08132 38.2596C-1.93569 43.44 1.717 50 7.63028 50H44.3691C50.2774 50 53.9366 43.4453 50.9196 38.2596ZM26 43.7822C24.3204 43.7822 22.9531 42.3871 22.9531 40.6732C22.9531 38.9594 24.3204 37.5643 26 37.5643C27.6796 37.5643 29.0469 38.9594 29.0469 40.6732C29.0469 42.3871 27.6796 43.7822 26 43.7822ZM29.0469 31.3465C29.0469 33.0603 27.6796 34.4554 26 34.4554C24.3204 34.4554 22.9531 33.0603 22.9531 31.3465V15.8018C22.9531 14.088 24.3204 12.6929 26 12.6929C27.6796 12.6929 29.0469 14.088 29.0469 15.8018V31.3465Z" fill="#487CAB"/>
                                                </svg>
                                                <p>Поддержание баланса воды в организме является ключевым фактором для поддержания здоровья и хорошего самочувствия. Сбалансированное количество воды может улучшить работу всех органов, физическую и умственную производительность, а также помочь уменьшить риск возникновения ряда заболеваний.</p>
                                            </div>
                                        </div>
                                        <div style={{width:'100%'}}>
                                            <hr />
                                            <div className='result'>
                                                <p>Калькулятор воды — это онлайн инструмент, который позволяет определить оптимальное количество воды, которое нужно выпить в течение дня, чтобы поддерживать здоровый уровень гидратации. Для использования калькулятора воды вам нужно указать свой вес, рост, возраст, уровень физической активности и климатические условия в своем регионе. На основе этих данных калькулятор рассчитывает ежедневную потребность в воде.</p>
                                                <p>Калькулятор воды может быть полезен для тех, кто хочет улучшить свое здоровье и поддерживать оптимальный уровень гидратации. Он может также использоваться для разработки плана потребления воды для спортсменов, людей, работающих на открытом воздухе, и для тех, кто находится в горячем климате или путешествует в  зоны с  высокой влажностью.</p>
                                                <p>Кроме того, калькулятор воды может помочь вам контролировать вашу потребление жидкости в течение дня. Например, если вы знаете, сколько воды вам нужно выпить, вы можете разбить эту сумму на несколько приемов в течение дня, чтобы обеспечить стабильный баланс воды в организме.</p>
                                                <p>Использование калькулятора воды — это простой и удобный способ узнать, сколько воды вам нужно пить, чтобы поддерживать здоровье и чувствовать себя лучше. Попробуйте наш калькулятор прямо сейчас и узнайте, как можно улучшить свой образ жизни через правильное употребление воды!</p>
                                            </div>
                                            <div className="fcenter custom_bg_text" style={{marginTop:50}}>
                                                <Link to={`/specializations/`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini_white" >Узнайте, как улучшить свой образ жизни</Link>
                                                <Link to={`/hls/surveys/`} exact={ true } onClick={() => scroll.scrollToTop()} className="submit_mini" >Пройдите тест и проверьте своё здоровье</Link>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};